import { render, staticRenderFns } from "./FeedId.vue?vue&type=template&id=8c9f83e2&scoped=true"
import script from "./FeedId.vue?vue&type=script&lang=js"
export * from "./FeedId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9f83e2",
  null
  
)

export default component.exports